import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'

import JsonViewer from 'components/JsonViewer'

const Targeting = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <Switch
        label='Enable Targeting'
        checked={!!content.enableTargeting}
        onChange={v => !disabled && onChange('enableTargeting')(v)}
      />

      <FieldLabel label='mBox name'>
        <Textfield
          placeholder=''
          name='mboxName'
          value={content.mboxName || ''}
          onChange={onChange('mboxName')}
          disabled={!content.enableTargeting || disabled}
        />
      </FieldLabel>

      <FieldLabel label=''>
        <JsonViewer content={content} buttonLabel='Show Sample Offer' dialogTitle='Sample Offer Content' indent={2} />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Targeting', content: Targeting }]
